module.exports = __webpack_public_path__ + "82f60bd0b94a1ed68b1e6e309ce2e8c3.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-css/themes/default/assets/fonts/outline-icons.svg
// module id = 257
// module chunks = 4